import { useCallback } from "react";
import { useHttpAdapter } from "./useHttpAdapter";
import type { PostAnalyticsData } from "../types/post-analytics";

interface PostAnalyticsResponse {
  status: string;
  data: PostAnalyticsData;
}

export const usePfmPostAnalyticsApi = () => {
  const { get } = useHttpAdapter();

  const getPostAnalytics = useCallback(
    async (postId: string): Promise<PostAnalyticsData | undefined> => {
      try {
        const url = `/pfm/post/analytics/${postId}`;
        const response = await get<PostAnalyticsResponse>(url);
        if (response.status === 200 && response.data?.data) {
          return response.data.data;
        }
        return undefined;
      } catch (e) {
        console.error("[PostAnalytics] Error:", e);
        return undefined;
      }
    },
    [get],
  );

  return { getPostAnalytics };
};
